export default "__VITE_ASSET__CfWP4OAE__"